import React, {useContext, useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Transition from '../../../mosaic/utils/Transition.jsx';
import {useTranslation} from "react-i18next";
import Spinner from "../../Spinner.jsx";
import UserDropdownProjectList from "./UserDropdownProjectList.jsx";
import {GlobalContext} from "../../../utils/context/GlobalContextProvider.jsx";
import IdentityImage from "../../IdentityImage.jsx";
import AccountSettingsModal from "../../../pages/userSettings/AccountSettingsModal.jsx";


function DropdownProfile({align}) {

    const {t} = useTranslation();

    const trigger = useRef(null);
    const dropdown = useRef(null);
    const [accountSettingsOpened, setAccountSettingsOpened] = useState(false);

    let {context, setUserDropdownOpened, setCurrentIdentity} = useContext(GlobalContext);

    let navigate = useNavigate();

    // close on click outside
    useEffect(() => {
        const clickHandler = ({target}) => {
            if (!dropdown.current) return;
            if (!context.userDropdownOpened || dropdown.current.contains(target) || trigger.current.contains(target)) return;
            setUserDropdownOpened(false);
        };
        document.addEventListener('click', clickHandler);
        return () => document.removeEventListener('click', clickHandler);
    });

    // close if the esc key is pressed
    useEffect(() => {
        const keyHandler = ({keyCode}) => {
            if (!context.userDropdownOpened || keyCode !== 27) return;
            setUserDropdownOpened(false);
        };
        document.addEventListener('keydown', keyHandler);
        return () => document.removeEventListener('keydown', keyHandler);
    });

    let currentProject = null;
    for (let project of context.currentUserProjects) {
        // noinspection JSUnresolvedReference
        if (project.id === context.currentProjectId) {
            // noinspection JSUnresolvedReference
            currentProject = project;
        }
    }

    if (context.currentIdentity === null || currentProject === null) {
        return <Spinner/>
    }

    return (
        <>
        <div className="relative inline-flex">
            <button
                ref={trigger}
                className="inline-flex max-w-[min(18rem,calc(100vw-7rem))] items-center justify-center rounded-lg group focus:outline-none focus:ring-0 focus-visible:bg-slate-100 focus-visible:outline-none focus-visible:ring-0 dark:focus-visible:bg-slate-800"
                aria-haspopup="true"
                onClick={() => setUserDropdownOpened(!context.userDropdownOpened)}
                aria-expanded={context.userDropdownOpened}
            >
                <div className="shrink-0">
                    <IdentityImage
                        url={context.currentIdentity.user.avatarUrl}
                        url2={currentProject.logoUrl}
                        project={currentProject}
                        user={context.currentIdentity.user}
                    />
                </div>
                <div className="flex min-w-0 flex-1 items-center">
                    <div className="flex min-w-0 flex-1 flex-col justify-start text-left">
                        <div
                            className="mx-2 truncate text-sm font-bold dark:text-slate-300 group-hover:text-slate-800 dark:group-hover:text-slate-200"
                            title={`${context.currentIdentity.user.firstName} ${context.currentIdentity.user.lastName}`.trim()}>
                            {context.currentIdentity.user.firstName}
                            &nbsp;
                            {context.currentIdentity.user.lastName}
                        </div>
                        <div className="mx-2 -mt-1 truncate text-xs font-normal text-violet-500 hover:text-violet-400 dark:text-violet-400 dark:hover:text-violet-300" title={currentProject.name}>
                            {currentProject.name}
                        </div>
                    </div>
                    <svg className="ml-1 h-3 w-3 shrink-0 fill-current text-slate-400" viewBox="0 0 12 12">
                        <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"/>
                    </svg>
                </div>
            </button>

            <Transition
                className={`dropdown-container-wrap origin-top-right z-60 absolute top-full w-[20rem] max-w-[calc(100vw-2rem)] overflow-hidden rounded-xl border border-[#b6bdc8] bg-white shadow-lg mt-1.5 dark:border-gray-500 dark:bg-slate-800 ${align === 'right' ? 'right-0' : 'left-0'}`}
                show={context.userDropdownOpened}
                enter="transition ease-out duration-200 transform"
                enterStart="opacity-0 -translate-y-2"
                enterEnd="opacity-100 translate-y-0"
                leave="transition ease-out duration-200"
                leaveStart="opacity-100"
                leaveEnd="opacity-0"
            >
                <div ref={dropdown}>

                    <UserDropdownProjectList/>

                    <div className="py-2">
                        <ul>
                            <li>
                                <div
                                    className="font-medium text-sm flex items-center py-1 px-3 cursor-pointer"
                                >
                                    {context.currentIdentity.user.email}
                                </div>
                            </li>
                            <li>
                            <span
                                className="text-violet-500 hover:text-violet-400 dark:text-violet-400 dark:hover:text-violet-300 font-medium text-sm flex items-center py-1 px-3 cursor-pointer"
                                onClick={() => {
                                    setUserDropdownOpened(false);
                                    setAccountSettingsOpened(true);
                                }}
                            >
                                {t('user.account-settings')}
                            </span>
                            </li>
                            <li>
                            <span
                                className="text-violet-500 hover:text-violet-400 dark:text-violet-400 dark:hover:text-violet-300 font-medium text-sm flex items-center py-1 px-3 cursor-pointer"
                                onClick={() => {
                                    // noinspection JSUnresolvedReference
                                    // window.FB.logout();
                                    setCurrentIdentity(null);
                                    navigate('/sign/in');
                                }}
                            >
                                {t('auth.sign-out')}
                            </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </Transition>
        </div>
        <AccountSettingsModal visible={accountSettingsOpened} setVisible={setAccountSettingsOpened}/>
        </>
    );
}

export default DropdownProfile;
